import { ICustomEntryPoint } from "../GameEntryPoint";
import { IGameState } from "../../IGameState";
import { addGateFriend } from "../../../Player/PlayerStateHelper";

export function gateUnlockAddFriendResponse(payload: ICustomEntryPoint, state: IGameState){
    // TODO: Maybe a pop-up saying "Your friend helped you!".
    return {
        ...state,
        playerState: addGateFriend(
            state.playerState,
            payload.userId,
            payload.userAvatar
        ),
    };
}
